import { useContext } from 'react'
import { ConfirmationContext, ConfirmationContextValue } from '@shared/contexts/ConfirmationContext'

/**
 * Hook to access the global confirmation service
 *
 * @returns Object with `confirm` method to trigger confirmation dialogs
 * @throws Error if used outside ConfirmationProvider
 *
 * @example
 * const { confirm } = useConfirm()
 *
 * const handleDelete = async () => {
 *   const confirmed = await confirm({
 *     title: 'Delete Item',
 *     description: 'Are you sure?',
 *     confirmText: 'Delete',
 *     variant: 'destructive'
 *   })
 *   if (confirmed) {
 *     // proceed with deletion
 *   }
 * }
 */
export function useConfirm(): ConfirmationContextValue {
  const context = useContext(ConfirmationContext)

  if (!context) {
    throw new Error('useConfirm must be used within ConfirmationProvider')
  }

  return context
}
